/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PraticaEsercenteEventoListFilter { 
    event_type?: Set<string>;
    actor_type?: Set<PraticaEsercenteEventoListFilterActorTypeEnum>;
    from?: string;
    to?: string;
}
export enum PraticaEsercenteEventoListFilterActorTypeEnum {
    CITTADINO = 'CITTADINO',
    OPERATORE = 'OPERATORE',
    SISTEMA = 'SISTEMA',
    ESTERNO = 'ESTERNO',
    CASSIERE = 'CASSIERE',
    ESERCENTE = 'ESERCENTE'
};



